import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const ConfirmationDialog = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  icon,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="flex items-center gap-3">
        {icon && (
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
            {icon}
          </div>
        )}
        <span className="text-lg font-semibold">{title}</span>
      </DialogTitle>

      <DialogContent className="!py-6">
        <p className="text-gray-700 mt-2">{message}</p>
      </DialogContent>

      <DialogActions className="!px-6 !py-4 gap-2">
        <Button onClick={onClose} className="bg-gray-200 text-gray-700 !px-6">
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          className="bg-red-600 text-white hover:bg-red-700 !px-6"
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
